module.exports = __webpack_public_path__ + "static/17-388072fab31d29334e3f16c83deffbff.png";